<template>
    <div class="payment">
        <div class="payment_container" v-if="!isGomLayout()">

            <div class="header">
                <CircleButton big="true" :icon="arrow_back_white" @circleBtnClick="navigateToCheckout"></CircleButton>
                <span>{{ getString('pagamento') }}</span>
                <DefaultButton v-if="!loggedClient" :text="getString('login_consumidor')"
                    @defaultBtnClick="clientLogin()"></DefaultButton>
                <DefaultButton v-else :text="buildLoggedPhrase()" @defaultBtnClick="showDialog()" singleLine="true">
                </DefaultButton>
            </div>
            <div class="content">
                <FidelityCardComponent v-if="casbackCampaign && [4, 5].includes(casbackCampaign.campaignEnabled)"></FidelityCardComponent>
                <span>{{ getString('informar_CPF_na_nota') }}</span>
                <div class="method-buttons">
                    <DefaultButton :text="idCliValue ? getString('alterar_cpf_cnpj') : getString('informa_cpf')" class="buttons"
                        @defaultBtnClick="openCPFModal()">
                    </DefaultButton>
                </div>
                <span v-text="guidancePhrase"></span>
                <div class="method-buttons-container" :class="{ 'casback-campaign': casbackCampaign && [4, 5].includes(casbackCampaign.campaignEnabled) }">
                    <div class="method-buttons">
                        <DefaultButton v-for="(method, key) in paymentMethods" :key="key" v-show="showMethod(method)"
                            :text="method.DSBUTTON" class="buttons" @defaultBtnClick="checkServiceTaxDialog(method)">
                        </DefaultButton>
                    </div>
                </div>
            </div>
            <transition name="bounce">
                <CPFModal v-if="showCPFModal" :cpf="idCliValue" @setIdCliValue="setIdCliValue"
                    @closeCpfModal="closeCpfModal"></CPFModal>
            </transition>
        </div>
        <div v-else class="payment_containter_gom">
            <div class="title-page">
                <img :src="getImage('logo') || header">
            </div>
            <div class="header">
                <CircleButton big="true" :icon="arrow_back_white" @circleBtnClick="goBack"></CircleButton>
                <span>{{ getString('pagamento') }}</span>
                <DefaultButton v-if="!loggedClient" :text="getString('login_consumidor')"
                    @defaultBtnClick="clientLogin()"></DefaultButton>
                <DefaultButton v-else :text="buildLoggedPhrase()" @defaultBtnClick="showDialog()" singleLine="true">
                </DefaultButton>
            </div>
            <div class="content">
                <Transition name="slide-fade-left-gom">
                    <div class="cpf-container" v-if="showCPFModal">
                        <CPFModalGom :cpf="idCliValue" :blockCnpjPdv="blockCnpjPdv" @setIdCliValue="setIdCliValue" @closeCpfModal="closeCpfModal">
                        </CPFModalGom>
                    </div>
                </Transition>
                <Transition name="slide-fade-gom">
                    <div class="method-buttons-container" v-if="showPaymentsMethods" :class="{'casback-campaign': casbackCampaign && [4, 5].includes(casbackCampaign.campaignEnabled) }">
                        <FidelityCardComponent v-if="casbackCampaign && [4, 5].includes(casbackCampaign.campaignEnabled)"></FidelityCardComponent>
                        <span v-text="guidancePhrase"></span>
                        <div class="method-buttons">
                            <DefaultButton v-for="(method, key) in paymentMethods" :key="key"
                                v-show="showMethod(method)" :text="method.DSBUTTON" class="buttons"
                                :paymentButtonGom="true" :icon="getTipoReceImg(method)"
                                @defaultBtnClick="checkServiceTaxDialog(method)">
                            </DefaultButton>
                        </div>
                    </div>
                </Transition>
            </div>
            <div class="payment-footer" v-show="loaded">
                    <DefaultButton :text="!isTapMode() ? getString('voltar_cardapio') : getString('voltar')"
                        @defaultBtnClick="!isTapMode() ? backToHome() : goBack()" layoutGom="true" outlined="true">
                    </DefaultButton>
                    <DefaultButton :text="!isTapMode() ? getString('cancelar_pedido') : getString('cancelar')"
                        @defaultBtnClick="clearCart()" layoutGom="true" outlined="true"></DefaultButton>
                </div>
            <div class="wallet-modal-target" ref="walletModalTarget"></div>
        </div>
        <div class="info-model" :class="{ 'androidMode': isAndroidMode() }" v-if="tefLoading">
            <template v-if="getImage('maquininha')">
                <img :src="getImage('maquininha')">
            </template>
            <template v-else>
                <h2>Siga as instruções na maquininha</h2>
                <div class="image-container">
                    <img :src="realize_pagamento">
                </div>
            </template>
            <div class="message">
                <span> {{ this.tefMessage }} </span>
            </div>
            <DefaultButton v-if="enableCancelButton" :text="getString('cancelar')" class="buttons" @defaultBtnClick="cancelPayment()"
                :outlined="true">
            </DefaultButton>
        </div>
        <div class="info-model" v-if="saleLoading || showPagerMessage">
            <div></div>
            <Loader :loading="saleLoading" :finish="successSale" v-if="!showPagerMessage"></Loader>
            <div v-else class="message_pager">
                <p>{{ getString('msg_pager') }} <br><br> {{ getString('msg_qrcode') }} </p>
                <img :src="qrCodePager" />
            </div>
            <DefaultButton v-if="showPagerMessage" :text="getString('voltar_agora')" class="buttons"
                @defaultBtnClick="closePrintModal()">
            </DefaultButton>
            <div v-else></div>
            <div class="message" :class="{ 'bold': this.saleMessage.bold }">
                <span v-text="this.saleMessage.text"></span>
                <br><br>
                <span v-text="this.catracaMessage" class="warning-message" v-if="this.hasCatraca"></span>
            </div>
        </div>

        <div ref="walletModalTarget"></div>
        <div class="overlay" v-if="showModal" @click="closeModal()"></div>
        <transition name="bounce">
            <PersonalCreditModal v-if="showModal" :method="personalCreditMethod" :changeConsumerFor="changeConsumerFor"
                @closeModal="closeModal" @personalCreditPayment="personalCreditPayment"
                @disableOverlayClick="overlayClickEnabled = false" @enableOverlayClick="overlayClickEnabled = true">
            </PersonalCreditModal>
        </transition>

        <div class="overlay" :class="{ 'success': successSale }"
            v-if="showPrintModal || showOverlay || showFidelityModal || saleLoading"></div>
        <transition name="bounce">
            <PrintModal v-if="showPrintModal" :printData="printData" @closePrintModal="closePrintModal">
            </PrintModal>
        </transition>
        <transition name="bounce">
            <FidelityModal v-if="showFidelityModal" @closeFidelitymodal="closeFidelitymodal"></FidelityModal>
        </transition>
        <CollectDataModal v-if="showCollectDataModal" :params="collectDataModalParams" @closeCollectDataModal="closeCollectDataModal"></CollectDataModal>
    </div>
</template>

<script>
import Vue from 'vue'
import VueTouchKeyboard from 'vue-touch-keyboard'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import LocaleController from '@/assets/controllers/LocaleController'
import PersonalCreditModal from '@/components/PersonalCreditModal'
import PrintModal from '@/components/PrintModal'
import WalletModal from '@/components/WalletModal'
import CircleButton from '@/components/CircleButton'
import DefaultButton from '@/components/DefaultButton'
import QuantityControl from '@/components/QuantityControl'
import CartController from '@/assets/controllers/CartController'
import PrinterController from '@/assets/controllers/PrinterController'
import PaymentController from '@/assets/controllers/PaymentController'
import SaleController from '@/assets/controllers/SaleController'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import Util from '@/assets/libs/util'
import ValidaCpfCnpj from '@/assets/libs/cpfcnpj'
import eventModule from '@/assets/libs/eventModule'
import PaymentTimeoutController from '@/assets/controllers/PaymentTimeoutController'
import CPFModalGom from '../components/CPFModalGom.vue'
import FidelityModal from '@/components/FidelityModal'
import CashbackCampaingController from '@/assets/controllers/CashbackCampaingController'
import CPFModal from '@/components/CPFModal'
import Loader from '../components/Loader.vue'
import CollectDataModal from '../components/CollectDataModal.vue'
import FidelityCardComponent from '@/components/FidelityComponents/FidelityCardComponent'
import moment from 'moment'
import ClarityController from '@/assets/controllers/ClarityController'

Vue.use(VueTouchKeyboard)
Vue.use(style)

export default {
    name: 'Checkout',
    components: {
        CircleButton,
        DefaultButton,
        QuantityControl,
        PersonalCreditModal,
        PrintModal,
        WalletModal,
        CPFModalGom,
        'vue-touch-keyboard': VueTouchKeyboard.component,
        FidelityModal,
        CPFModal,
        Loader,
        CollectDataModal,
        FidelityCardComponent
    },
    data () {
        return {
            showModal: false,
            showOverlay: false,
            showPrintModal: false,
            removeConfirmImpressaoCupom: Util.getLocalConfigs('removeConfirmImpressaoCupom'),
            printData: null,
            personalCreditMethod: null,
            overlayClickEnabled: true,
            changeConsumerFor: '',
            valueAvailable: 0,
            cart: CartController.getCart(),
            paymentMethods: PaymentController.getPaymentMethods(),
            showCpfFieldValue: false,
            showCPFModal: false,
            visible: false,
            layout: 'normal',
            input: null,
            loginName: null,
            loading: false,
            tefLoading: false,
            saleLoading: false,
            printing: false,
            chooseWallet: false,
            qrCodeEventData: null,
            dynamicMask: '###.###.###-##',
            idCliValue: '',
            addressData: null,
            consumerName: CartController.getConsumerName(),
            showNameModal: false,
            allowComplement: Util.getLocalConfigs('allowComplement'),
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            paymentMode: 0,
            guidancePhrase: '',
            excess: 0,
            loggedClient: false,
            showPaymentsMethods: false,
            realize_pagamento: require('../../static/icons/tef.svg'),
            impressao_recibo: require('../../static/icons/impressao_recibo.jpg'),
            arrow_back_white: require('../../static/icons/arrow_back_white.svg'),
            icon_pix: require('../../static/icons/pix.png'),
            icon_card: require('../../static/icons/taa_icon_credit.jpeg'),
            icon_money: require('../../static/icons/taa_icon_debit.jpeg'),
            icon_default: require('../../static/icons/taa_icon_debit.jpeg'),
            header: require('../../static/client/header.png'),
            cashbackCampaign: null,
            cashbackCampaignProcessed: false,
            showFidelityModal: false,
            selectedMethod: null,
            tefMessage: '',
            saleMessage: {
                text: '',
                bold: false
            },
            successSale: false,
            loaded: false,
            showPagerMessage: false,
            qrCodePager: '',
            loading_gif: require('../../static/icons/loading.gif'),
            success_gif: require('../../static/icons/success.gif'),
            enableCancelButton: false,
            cancelando: false,
            showCollectDataModal: false,
            collectDataModalParams: {
                title: '',
                type: '',
                minLength: 0,
                maxLength: 0
            },
            casbackCampaign: null,
            idSolDigCons: Util.getLocalConfigs('idSolDigCons'),
            blockCnpjPdv: Util.getLocalConfigs('blockCnpjPdv'),
            catracaMessage: LocaleController.getString('aguardando_confirmacao_catraca'),
            hasCatraca: Util.getLocalConfigs('hasTurnstile') && Util.isTapMode()
        }
    },
    created () {
        this.guidancePhrase = this.loadGuidancePhrase()
        this.loggedClient = IdentifiedConsumerController.userIsLogged()
        this.getCashbackCampaignStatus()
        if (this.loggedClient) {
            this.reapplyDiffPrices()
        }
        if (this.isGomLayout()) {
            this.openCPFModal()
        }
        eventModule.$on('showWalletOptions', this.showWalletOptions)
        eventModule.$on('qrCodeReceived', this.qrCodeReceived)
        eventModule.$on('setTefMessage', this.setTefMessage)
        eventModule.$on('hideLoadingTef', this.hideLoadingTef)
        eventModule.$on('showLoadingSale', this.showLoadingSale)
        eventModule.$on('hideLoadingSale', this.hideLoadingSale)
        eventModule.$on('setSaleMessage', this.setSaleMessage)
        eventModule.$on('setSuccessSale', this.setSuccessSale)
        eventModule.$on('toggleCancelButton', this.toggleCancelButton)
        eventModule.$on('showCollectDataModal', this.openCollectDataModal)
        eventModule.$on('finishTefTransaction', this.finishTefTransire)
    },
    beforeDestroy () {
        eventModule.$off('showWalletOptions', this.showWalletOptions)
        eventModule.$off('qrCodeReceived', this.qrCodeReceived)
        eventModule.$off('setTefMessage', this.setTefMessage)
        eventModule.$off('hideLoadingTef', this.hideLoadingTef)
        eventModule.$off('showLoadingSale', this.showLoadingSale)
        eventModule.$off('hideLoadingSale', this.hideLoadingSale)
        eventModule.$off('setSaleMessage', this.setSaleMessage)
        eventModule.$off('toggleCancelButton', this.toggleCancelButton)
        eventModule.$off('setSuccessSale', this.setSuccessSale)
        eventModule.$off('showCollectDataModal', this.openCollectDataModal)
        eventModule.$off('finishTefTransaction', this.finishTefTransire)
        /* if (CartController.hasAppliedDiffPrices()) {
            CartController.restoreOriginalPrices()
        } */
        if (this.$refs.modal) {
            this.$refs.modal.$off('closeWalletModal', this.closeWalletModal)
            this.$refs.modal.$destroy()
            this.$refs.modal = null
        }

        PaymentTimeoutController.clear()
    },
    mounted () {
        let sf = this
        setTimeout(() => {
            sf.loaded = true
        }, 1000)
        if (this.cart.length === 0) {
            // caso o carrinho esteja vazio volte para a home para evitar erro de pagamento
            Util.showInfoModal(this.getString('erro_comanda_vazia'))
            this.$router.push('Home')
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        sanitizeCpfCnpj: function () {
            if (this.dynamicMask === '###.###.###-##') {
                this.idCliValue = this.idCliValue.replace(/[^0-9.-]+/g, '')
            } else {
                this.idCliValue = this.idCliValue.replace(/[^A-Z0-9/.-]+/g, '').toUpperCase()
            }
        },
        reapplyDiffPrices: async function () {
            if (!Util.isTapMode()) {
                await CartController.applyDifferentiatedPrices()
            }
        },
        clientLogin: function () {
            this.showLoginModal()
        },
        showDialog: function () {
            if (Util.isTapMode()) {
                this.showChangeUserDialog()
            } else {
                this.showLogoutDialog()
            }
        },
        showChangeUserDialog: function () {
            Util.showConfirmationDialog(this.$modal,
                () => {
                    this.clientLogin()
                },
                this.getString('realizar_login_outro_usuario')
            )
        },
        showLogoutDialog: function () {
            Util.showConfirmationDialog(this.$modal,
                () => {
                    this.clientLogout()
                },
                this.getString('deseja_realizar_logoff_usuario')
            )
        },
        clientLogout: function () {
            IdentifiedConsumerController.userLogout()

            if (CartController.hasAppliedDiffPrices()) {
                CartController.restoreOriginalPrices()
            }

            this.loggedClient = IdentifiedConsumerController.userIsLogged()
        },
        buildLoggedPhrase: function () {
            let consumerData = IdentifiedConsumerController.getConsumerData()
            let hasConsumerName = consumerData && consumerData.consumerName && consumerData.consumerName !== ''
            let hasConsumerId = consumerData && consumerData.consumerId && consumerData.consumerId !== ''

            if (hasConsumerName) {
                return this.getString('logado_como') + ` ${consumerData.consumerName}`
            } else if (hasConsumerId) {
                return this.getString('logado_como') + ` ${consumerData.consumerId}`
            } else {
                return this.getString('usuario_logado')
            }
        },
        changeScreenToFirstPayment: function () {
            this.paymentMode++
            this.guidancePhrase = this.loadGuidancePhrase()
            this.paymentMethods = this.paymentMethods.filter(
                method => method.IDTIPORECE !== '9' && method.IDTIPORECE !== 'A' && method.IDTIPORECE !== '4'
            )
        },
        loadGuidancePhrase: function () {
            const phraseMap = {
                0: this.getString('escolha_forma_pagamento'),
                1: this.getString('escolha_forma_pagamento_complementar')
            }
            return phraseMap[this.paymentMode]
        },
        showMethod: function (method) {
            let isTap = Util.isTapMode()
            let isCashMethod = method.IDTIPORECE === '4'
            let isOracle = Util.isOracle()

            let allowedMethodForUser = true
            let isPersonalCredit = method.IDTIPORECE === '9'
            let isConsumerDebit = method.IDTIPORECE === 'A'

            if (isPersonalCredit || isConsumerDebit) {
                let userIsLogged = IdentifiedConsumerController.userIsLogged()
                let consumerData = IdentifiedConsumerController.getConsumerData()

                if (userIsLogged && isPersonalCredit) {
                    let allowPersonalCredit = consumerData && consumerData.typeSaleAllowed && consumerData.typeSaleAllowed.allowPersonalCredit
                    allowedMethodForUser = allowPersonalCredit
                }

                if (userIsLogged && isConsumerDebit) {
                    let allowConsumerDebit = consumerData && consumerData.typeSaleAllowed && consumerData.typeSaleAllowed.allowConsumerDebit
                    allowedMethodForUser = allowConsumerDebit
                }
            }

            return !((isTap || isOracle) && isCashMethod) && allowedMethodForUser
        },
        closeModal: function () {
            if (this.overlayClickEnabled) {
                this.showModal = false
                this.loggedClient = IdentifiedConsumerController.userIsLogged()
            }
        },
        openPrintModal: function (printData) {
            this.printData = printData
            this.showPrintModal = true
        },
        closePrintModal: function () {
            this.showPrintModal = false
            this.saleLoading = false
            CartController.clearCartAndNavigateHome(this.$router)
        },
        personalCreditPayment: function (method) {
            this.showModal = false
            this.loggedClient = IdentifiedConsumerController.userIsLogged()
            let isPersonalCredit = method.IDTIPORECE === '9'
            let isConsumerDebit = method.IDTIPORECE === 'A'
            let result = null // IdentifiedConsumerController.canProceedToPayment(method)
            if (this.cashbackCampaignStatus && !this.cashbackCampaignProcessed && method.IDTIPORECE !== '4') {
                this.cashbackCampaignProcessed = true
                this.getFidelityBalance()
            } else {
                if (isConsumerDebit || isPersonalCredit) {
                    result = IdentifiedConsumerController.canProceedToPayment(method)
                    if (result.canProceed) {
                        this.doPayment(method)
                        if (result.showWarning) {
                            Util.showInfoModal(result.warningMessage)
                        }
                    } else if (result.code !== '001') {
                        this.excess = IdentifiedConsumerController.calculateExcessValue(method)
                        if (!this.allowComplement) {
                            Util.showInfoModal(this.getString('complemento_nao_permitido'))
                            return false
                        } else {
                            this.showComplementDialog(result, method)
                        }
                    } else {
                        Util.showInfoModal(result.message)
                    }
                } else {
                    this.methodSelect(method)
                }
            }
        },
        showWalletOptions: function () {
            if (!PaymentController.isInRechargeMode() && !this.chooseWallet) {
                this.openWalletModal()
            }
        },
        openWalletModal: function () {
            const ComponentClass = Vue.extend(WalletModal)
            const instance = new ComponentClass({
                propsData: {
                    qrCodeEventData: this.qrCodeEventData
                }
            })

            instance.$on('closeWalletModal', this.closeWalletModal)
            instance.$mount()
            this.$refs.walletModalTarget.appendChild(instance.$el)
            this.$refs.modal = instance

            this.chooseWallet = true
        },
        qrCodeReceived: function (eventData) {
            if (!PaymentController.isInRechargeMode()) {
                if (!this.chooseWallet) {
                    this.qrCodeEventData = eventData
                    this.openWalletModal()
                } else {
                    eventModule.$emit('qrCodeForwarded', eventData)
                }
            }
        },
        closeWalletModal: function () {
            this.chooseWallet = false
            if (this.$refs.modal) {
                this.$refs.walletModalTarget.removeChild(this.$refs.modal.$el)
                this.$refs.modal.$destroy()
                this.$refs.modal = null
            }
        },
        dontNeedAnotherPayment: function () {
            let cartTotal = CartController.getTotalPriceAsFloat()
            return this.excess === cartTotal
        },
        checkServiceTaxDialog: function (method) {
            let isTapMode = Util.isTapMode()
            let hasServiceTax = this.hasServiceTax()
            let fixedServiceTax = Util.getLocalConfigs('fixedServiceTax')
            let automaticServiceTax = Util.getLocalConfigs('automaticServiceTax')
            let isFirstOpportunityToShow = this.paymentMode === 0
            this.selectedMethod = method
            if (((Util.isNfseMode() && !Util.isTapMode()) || Util.isInfoConsTaa()) && !this.loggedClient && isFirstOpportunityToShow) {
                this.showLoginModal(method)
            } else {
                if (isTapMode && hasServiceTax && fixedServiceTax && isFirstOpportunityToShow && !automaticServiceTax) {
                    this.showServiceTaxDialog(method)
                } else {
                    this.methodSelect(method)
                }
            }
        },
        hasServiceTax: function () {
            let comandasAgregadas = CartController.getComandasAgregadas()
            return (comandasAgregadas && comandasAgregadas[0] && comandasAgregadas[0].serviceTax !== null)
        },
        showServiceTaxDialog: function (method) {
            let serviceTax = CartController.getMainComandaAgregada().serviceTax
            let formattedServiceTax = Util.formatMoney(serviceTax)
            let message = this.getString('adicionar_taxa_servico') + `${formattedServiceTax}?`
            if (serviceTax && serviceTax > 0.01) {
                Util.showConfirmationDialog(this.$modal,
                    () => {
                        this.methodSelect(method)
                        CartController.getMainComandaAgregada().serviceTaxApplied = true
                    },
                    message,
                    async () => {
                        if (Util.getLocalConfigs('removTXServTap')) {
                            await this.removeServiceTax()
                            this.methodSelect(method)
                            CartController.getMainComandaAgregada().serviceTaxApplied = false
                        } else {
                            Util.showInfoModal(this.getString('va_ao_caixa'))
                        }
                    }
                )
            } else {
                this.methodSelect(method)
            }
        },
        removeServiceTax: async function () {
            let mainComandaAgregada = CartController.getMainComandaAgregada()
            let removedServiceTax = 0.001
            await SaleController.editServiceTax(mainComandaAgregada.saleCode, removedServiceTax)
            mainComandaAgregada.serviceTax = removedServiceTax
        },
        methodSelect: async function (method, ignoreLogin = false) {
            ClarityController.event('usuario_selecionou_metodo_pagamento')
            ClarityController.setTag('metodo_pagamento', method.NMTIPORECE)
            this.selectedMethod = method
            if (this.cashbackCampaignStatus && !this.cashbackCampaignProcessed && method.IDTIPORECE !== '4') {
                this.cashbackCampaignProcessed = true
                this.getFidelityBalance()
            } else {
                eventModule.$emit('setCountDownTimeOut', false) // desabilita o countDownTimeOut quando o tef for iniciado ou o salvamento da venda
                if (method.IDTIPORECE !== '9' && method.IDTIPORECE !== 'A' && method.IDTIPORECE !== '4') {
                    PaymentTimeoutController.start()
                }

                let dontNeedAnotherPayment = this.dontNeedAnotherPayment()
                if (this.showCpfFieldValue) {
                    if (!ValidaCpfCnpj.validaCpfCnpj(this.idCliValue)) {
                        Util.showInfoModal(this.getString('CPF_CNPJ_invalido'))
                        return false
                    }
                }
                this.visible = false

                // rotinas de pagamento único
                if (this.paymentMode === 0 || dontNeedAnotherPayment) {
                    // IDTIPORECE === '9' é credito pessoal. IDTIPORECE === 'A' é debito consumidor
                    if ((method.IDTIPORECE === '9' || method.IDTIPORECE === 'A') && ignoreLogin !== true) {
                        this.showLoginModal(method)
                    } else {
                        this.doPayment(method)
                    }

                    // rotinas de pagamento principal (crédito pessoal ou débito consumidor) + complemento (cartão ou PIX)
                } else {
                    if ((method.IDTIPORECE === '9' || method.IDTIPORECE === 'A')) {
                        this.doPrincipalPayment(method)
                    } else {
                        this.doComplementaryPayment(method)
                    }
                }
            }
        },
        showComplementDialog: function (result, method) {
            let excessValue = Util.formatMoney(this.excess)
            let message = `${result.message}` + this.getString('deseja_complementar') + `${excessValue}` + this.getString('com_outra_forma_pagamento')

            Util.showConfirmationDialog(this.$modal,
                () => {
                    IdentifiedConsumerController.setPrincipalPaymentMethod(method)
                    this.changeScreenToFirstPayment()
                },
                message
            )
        },
        navigateToCheckout: function () {
            if (this.printing) {
                this.hidePrintingImage()
            }
            if (this.idSolDigCons) {
                PaymentController.navigateToConsumer(this.$router)
            } else {
                PaymentController.navigateToCheckout(this.$router)
            }
        },
        goBack: function () {
            const { campaignEnabled } = CashbackCampaingController.getDiscountApplied()
            if (campaignEnabled === 5) {
                CashbackCampaingController.clearData()
            }
            if (this.isGomLayout()) {
                if (!this.showPaymentsMethods) {
                    if (this.idSolDigCons) {
                        PaymentController.navigateToConsumer(this.$router)
                    } else {
                        PaymentController.navigateToCheckout(this.$router)
                    }
                } else {
                    this.openCPFModal()
                }
            } else {
                if (this.printing) {
                    this.hidePrintingImage()
                }
                PaymentController.navigateToConsumer(this.$router)
                // PaymentController.navigateToCheckout(this.$router)
            }
        },
        showLoginModal: function (method) {
            this.personalCreditMethod = method
            this.showModal = true
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                this.layout = e.target.dataset.layout

                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        doPayment: async function (paymentMethod) {
            this.tefMessage = ''
            this.saleMessage.text = ''
            this.saleMessage.bold = false
            if (paymentMethod.IDTIPORECE === '4') {
                this.showPrintingImage()
            } else if (!['A', '9'].includes(paymentMethod.IDTIPORECE)) {
                if (CartController.getTotalPriceAsFloat() <= 0 && paymentMethod.IDTIPORECE !== '4') {
                    Util.showInfoModal('carrinho_valor_0')
                    return false
                }
                this.showLoadingTef()
            }

            let hasToAwaitScreenUpdate = Util.isAndroidMode() && (paymentMethod.IDTIPORECE === '1' ||
                paymentMethod.IDTIPORECE === '2' || paymentMethod.IDTIPORECE === 'H')
            if (hasToAwaitScreenUpdate) await Util.sleep(200)

            let paymentResponse = await PaymentController.doPayment(paymentMethod, this.idCliValue, this.$router)
            let printResult = false
            eventModule.$emit('setCountDownTimeOut', true) // habilita o countDownTimeOut
            if (paymentResponse && paymentResponse.error) {
                this.handleTefError(paymentResponse)
            } else if (paymentResponse && paymentResponse.printData) {
                if (paymentMethod.IDTIPORECE === '4') {
                    this.hidePrintingImage()
                } else {
                    this.hideLoadingTef(true)
                }
                this.successSale = true
                paymentResponse.printData.tefData = PaymentController.getComprovanteTef()
                ClarityController.event('usuario_concluiu_pagamento')
                if (!this.removeConfirmImpressaoCupom) {
                    this.openPrintModal(paymentResponse.printData)
                    await this.delay(0.5)
                    this.hideLoadingSale()
                } else {
                    this.saleMessage.text = this.getString('imprimindo_cupom')
                    this.showOverlay = true
                    printResult = await PrinterController.printCoupons(paymentResponse.printData, false, false, '', this.$router)
                    if (printResult) {
                        this.saleMessage.text = this.getString('cupom_impresso')
                        await this.delay(1)
                        if (paymentResponse.printData && paymentResponse.printData.saleData && paymentResponse.printData.saleData.urlPager) {
                            this.qrCodePager = paymentResponse.printData.saleData.qrCodePager
                            this.showPagerMessage = true
                            let cont = 15
                            while (cont > 0) {
                                this.saleMessage.text = `${this.getString('voltar_tela_inicial')} ${cont}`
                                await this.delay(1)
                                cont--
                            }
                        }
                        this.hideLoadingSale()
                        CartController.clearCartAndNavigateHome(this.$router)
                    }
                }
            }
            PaymentTimeoutController.clear()
        },
        doComplementaryPayment: async function (paymentMethod) {
            if (!['A', '9'].includes(paymentMethod.IDTIPORECE)) {
                this.showLoadingTef()
            }
            let hasToAwaitScreenUpdate = Util.isAndroidMode() && (paymentMethod.IDTIPORECE === '1' ||
                paymentMethod.IDTIPORECE === '2' || paymentMethod.IDTIPORECE === 'H')
            if (hasToAwaitScreenUpdate) await Util.sleep(200)

            let paymentResponse = await PaymentController.doComplementaryPayment(paymentMethod, this.idCliValue, this.$router, this.excess)

            if (paymentResponse && paymentResponse.error) {
                this.handleTefError(paymentResponse)
            } else {
                IdentifiedConsumerController.setCompPaymentData(paymentMethod, this.excess, paymentResponse.paymentNumber,
                    paymentResponse.date, paymentResponse.hour, paymentResponse.cupomFiscalSitef, paymentResponse.authHash
                )
                let principalPaymentMethod = IdentifiedConsumerController.getCompPaymentData().principalPaymentMethod
                this.doPrincipalPayment(principalPaymentMethod)
                this.hideLoadingTef()
            }
            PaymentTimeoutController.clear()
        },
        doPrincipalPayment: async function (paymentMethod) {
            if (!['A', '9'].includes(paymentMethod.IDTIPORECE)) {
                this.showLoadingTef()
            }
            let printResult = false
            let paymentResponse = await PaymentController.doPrincipalPayment(paymentMethod, this.idCliValue, this.$router)
            eventModule.$emit('setCountDownTimeOut', true) // habilita o countDownTimeOut
            if (paymentResponse && paymentResponse.printData) {
                this.hideLoadingTef(true)
                this.successSale = true
                await this.delay(1)
                if (!this.removeConfirmImpressaoCupom) {
                    this.openPrintModal(paymentResponse.printData)
                    await this.delay(0.5)
                    this.hideLoadingSale()
                } else {
                    this.saleMessage.text = this.getString('imprimindo_cupom')
                    this.showOverlay = true
                    printResult = await PrinterController.printCoupons(paymentResponse.printData, false, this.$router)
                    if (printResult) {
                        await this.delay(1)
                        if (paymentResponse.printData && paymentResponse.printData.saleData && paymentResponse.printData.saleData.urlPager) {
                            this.qrCodePager = paymentResponse.printData.saleData.qrCodePager
                            this.showPagerMessage = true
                            let cont = 15
                            while (cont > 0) {
                                this.saleMessage.text = `${this.getString('voltar_tela_inicial')} ${cont}`
                                await this.delay(1)
                                cont--
                            }
                        }
                        this.hideLoadingSale()
                        CartController.clearCartAndNavigateHome(this.$router)
                    }
                }
            }
        },
        concomitantTefTransactionError: function (paymentResponse) {
            return paymentResponse && paymentResponse.error === true && paymentResponse.errorType === 'concomitant tef transaction'
        },
        handleConcomitantTefTransactionError: function () {
            // Não exibir nada na tela, a rotina TEF iniciada primeiro deve seguir normalmente e o usuário não deve ser
            // alertado da tentativa de iniciar a segunda
        },
        tefError: function (paymentResponse) {
            return paymentResponse && paymentResponse.error === true && paymentResponse.errorType === 'tef error'
        },
        handleTefError: function (paymentResponse) {
            this.hideLoadingTef()
            this.forceModalCloseOnAndroid()
            Util.showInfoModal(paymentResponse.errorType || this.getString('problema_nao_identificado_TEF_tente_novamente'))
        },
        forceModalCloseOnAndroid: function () {
            if (this.chooseWallet) {
                this.closeWalletModal()
            }
        },
        showCpfField: function (value) {
            this.showCpfFieldValue = value
            if (value) {
                setTimeout(() => {
                    document.getElementById('cpf_field').focus()
                }, 300)
            }
        },
        getImage: function (value) {
            return Util.getConfigImage(value)
        },
        showLoadingImage: function () {
            this.loading = true
        },
        hideLoadingImage: function () {
            this.showOverlay = false
            this.loading = false
        },
        showLoadingTef: function () {
            this.showOverlay = true
            this.tefLoading = true
        },
        hideLoadingTef: function (overlay = false) {
            this.showOverlay = overlay
            this.tefLoading = false
        },
        setTefMessage: function (text) {
            this.tefMessage = text
        },
        showLoadingSale: function () {
            this.saleLoading = true
        },
        hideLoadingSale: function () {
            this.saleMessage.text = ''
            this.saleMessage.bold = false
            this.saleLoading = false
        },
        setSaleMessage: function (message) {
            this.saleMessage.text = message.text || ''
            this.saleMessage.bold = message.bold || false
        },
        showPrintingImage: function () {
            this.printing = true
        },
        hidePrintingImage: function () {
            this.printing = false
        },
        isGomLayout: function () {
            return Util.getLocalConfigs('utiliza_layout_gom')
        },
        backToHome: function () {
            this.$router.push('home')
        },
        clearCart: function () {
            if (CartController.isCartEmpty()) {
                this.$router.push('/')
            } else {
                CartController.clearCart(this, '/')
            }
        },
        getTipoReceImg: function (method) {
            const methods = {
                'H': this.icon_pix,
                '1': this.icon_card,
                '2': this.icon_card,
                '4': this.icon_money,
                'default': this.icon_default
            }
            if (!method || !method.IDTIPORECE) {
                return false
            }
            return methods[method.IDTIPORECE] || methods['default']
        },
        openCPFModal: function () {
            if (!this.isGomLayout()) {
                this.showOverlay = true
            }
            this.showPaymentsMethods = false
            this.showCPFModal = true
        },
        openFidelityModal: function () {
            this.showFidelityModal = true
            this.showOverlay = true
        },
        closeFidelitymodal: function () {
            this.showFidelityModal = false
            this.showOverlay = false
            let ignoreLogin = !!this.loggedClient || false // ignora o login caso ja realizado
            this.methodSelect(this.selectedMethod, ignoreLogin)
        },
        getFidelityBalance: async function () {
            this.showOverlay = true
            let totalValue = CartController.getTotalPriceAsFloat()

            CashbackCampaingController.setTotalSaleValue(totalValue)
            await CashbackCampaingController.getBalance(totalValue)
            let cashbackBonus = CashbackCampaingController.getCashbackBonusValue()
            console.log('cashbackBonus', cashbackBonus)
            if (cashbackBonus.available > 0) {
                this.openFidelityModal()
            } else {
                CashbackCampaingController.setProcessedStatus(true)
                this.showOverlay = false
                this.methodSelect(this.selectedMethod)
            }
        },
        getCashbackCampaignStatus: async function () {
            let status = await CashbackCampaingController.getStatus()
            this.casbackCampaign = status
            this.cashbackCampaignStatus = !status.processed && status.status && status.campaignEnabled !== 'none'
        },
        closeCpfModal: function () {
            this.showOverlay = false
            this.showCPFModal = false
            this.showPaymentsMethods = true
        },
        setIdCliValue: function (cpf, addressData) {
            this.idCliValue = cpf

            if (addressData) {
                SaleController.setAddressData(addressData)
            }

            if (this.casbackCampaign && this.casbackCampaign.campaignEnabled === 5) {
                if (cpf) {
                    CashbackCampaingController.setDocumentNumber(cpf)
                    eventModule.$emit('crmFixeClientLoading')
                    CashbackCampaingController.getClientInfo(cpf).then((result) => {
                        eventModule.$emit('crmFixeClientLoaded', result)
                    })
                } else {
                    eventModule.$emit('crmFixeClearData')
                }
            }
            this.closeCpfModal()
        },
        delay: function (seconds) {
            return new Promise(function (resolve) {
                setTimeout(resolve, seconds * 1000)
            })
        },
        setSuccessSale: function (value) {
            this.successSale = value
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        isTapMode: function () {
            return Util.isTapMode()
        },
        cancelPayment: function () {
            PaymentController.cancelPayment()
        },
        toggleCancelButton: function (status) {
            this.enableCancelButton = status
        },
        openCollectDataModal: function (data) {
            this.collectDataModalParams = data
            this.showCollectDataModal = true
            this.overlayClickEnabled = false
        },
        closeCollectDataModal: function () {
            this.showCollectDataModal = false
            // this.showOverlay = false
        },
        finishTefTransire: async function (result) {
            let resultJson = result
            if (resultJson.finalResult !== 'APPROVED') {
                let error = this.handleTefTransireResultAndroid(resultJson.finalResult)
                eventModule.$emit('setTefMessage', error)
                setTimeout(() => {
                    eventModule.$emit('hideLoadingTef', false)
                    Util.showInfoModal(error)
                }, 200)
                return false
            }
            const dataTransire = PaymentController.getDataTransire()
            const date = dataTransire.date
            const hour = dataTransire.hour
            const orderCPF = dataTransire.consumerCpf
            const router = dataTransire.router
            const cupomFiscalSitef = date + hour + moment().milliseconds()
            const paymentNumber = resultJson.nsu
            const authHash = resultJson.authCode
            const paymentSelectedMethod = dataTransire.paymentSelectedMethod
            const paymentResponse = await SaleController.performSale(paymentNumber, authHash, paymentSelectedMethod, orderCPF, router, date, hour, false, cupomFiscalSitef, true)
            let printResult = false
            eventModule.$emit('setCountDownTimeOut', true) // habilita o countDownTimeOut
            if (paymentResponse && paymentResponse.error) {
                this.handleTefError(paymentResponse)
            } else if (paymentResponse && paymentResponse.printData) {
                if (paymentSelectedMethod.IDTIPORECE === '4') {
                    this.hidePrintingImage()
                } else {
                    this.hideLoadingTef(true)
                }
                this.successSale = true
                paymentResponse.printData.tefData = PaymentController.getComprovanteTef()
                if (!this.removeConfirmImpressaoCupom) {
                    this.openPrintModal(paymentResponse.printData)
                    await this.delay(0.5)
                    this.hideLoadingSale()
                } else {
                    this.saleMessage.text = this.getString('imprimindo_cupom')
                    this.showOverlay = true
                    printResult = await PrinterController.printCoupons(paymentResponse.printData, false, false, '', this.$router)
                    if (printResult) {
                        this.saleMessage.text = this.getString('cupom_impresso')
                        await this.delay(1)
                        if (paymentResponse.printData && paymentResponse.printData.saleData && paymentResponse.printData.saleData.urlPager) {
                            this.qrCodePager = paymentResponse.printData.saleData.qrCodePager
                            this.showPagerMessage = true
                            let cont = 15
                            while (cont > 0) {
                                this.saleMessage.text = `${this.getString('voltar_tela_inicial')} ${cont}`
                                await this.delay(1)
                                cont--
                            }
                        }
                        this.hideLoadingSale()
                        CartController.clearCartAndNavigateHome(this.$router)
                    }
                }
            }
            PaymentTimeoutController.clear()
        },
        handleTefTransireResultAndroid: function handleTefTransireResultAndroid (finalResult) {
            const errors = {
                'REPROVED_HOST': 'Transação cancelada pelo host',
                'REPROVED_CARD': 'Transação reprovada pelo cartão',
                'TIMEOUT': 'Tempo de espera excedido',
                'CANCELLED': 'Transação cancelada',
                'ERROR': 'Erro desconhecido'
            }
            if (finalResult && errors[finalResult]) {
                return errors[finalResult]
            }
            return errors['ERROR']
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.payment {
    height: 100%;

    .payment_container {
        padding: 2rem;
        overflow: hidden;
        // background: lightgray;
        background: @white;
        height: 100%;

        .header {
            display: flex;
            align-items: center;
            margin-bottom: 3rem;
            justify-content: space-between;

            span {
                font-size: 3rem;
                color: @primary-dark;
                font-weight: bold;

                &:last-child {
                    margin: auto;
                }
            }
        }

        span {
            font-size: 3rem;
            color: @primary-dark;
            font-weight: bold;

            &:last-child {
                margin: auto;
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-height: calc(100% - 180px);
            width: 100%;

            span {
                margin-top: 2rem;
                margin-bottom: 2rem;
                font-size: 2rem;
                color: @black;
                display: block;
                font-weight: bold;
            }

            .buttons {
                margin-bottom: 2rem;
            }

            .radios {
                font-size: 2rem;
                margin-bottom: 2rem;

                input {
                    margin-left: 2rem;
                }

                .container-input {
                    height: 37px;
                    display: inline-block;
                    vertical-align: middle;

                    #cpf,
                    #cnpj {
                        margin: 0;
                    }

                    .checkmark {
                        margin: 0;
                        border-radius: 100%;
                        pointer-events: none;

                        &:after {
                            border: none;
                            background: white;
                            border-radius: 100%;
                            width: 10px;
                            left: 8px;
                            top: 7px;
                        }
                    }
                }

                label {
                    display: inline-block;
                    vertical-align: middle;

                    &:not(&:last-of-type) {
                        margin-right: 30px;
                    }
                }
            }

            .cpf_field {
                width: 30rem;
                height: 4rem;
                font-size: 3rem;
                border-color: @primary-color;
                border-radius: 10px;
                text-align: center;
            }

            input:focus {
                outline: none;
                border-color: @primary-dark;
            }

            .method-buttons-container {
                width: 100%;
                max-height: 100%;
                overflow: auto;

                .method-buttons {
                    margin: auto;
                    display: block;

                    .button-default {
                        margin-left: auto;
                        margin-right: auto;
                        width: 380px;
                    }
                }
            }
        }
    }

    .payment_containter_gom {
        display: grid;
        grid-template-rows: 180px 150px calc(100vh - 520px) 130px 0;
        overflow: hidden;
        background: @white;
        height: calc(100vh - 60px);

        .title-page {
            display: flex;
            justify-content: center;
            // align-items: center;
            margin: 0 0 30px 0;
            background-color: @header-color;
            width: 100vw;
            height: 180px;

            img {
                height: 160px;
                padding: 10px 0;
            }
        }

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 2rem;
            span {
                font-size: 3rem;
                color: @primary-dark;
                // font-weight: bold;
                text-transform: uppercase;

                &:last-child {
                    margin: auto;
                }
            }
        }

        .content {
            padding: 0 2rem;
            position: relative;
            overflow: hidden;
            min-height: 500px;
            width: 100%;
            box-sizing: border-box;

            span {
                margin: 2rem 0;
                font-size: 2rem;
                color: @black;
                display: block;
                font-weight: bold;
            }

            .buttons {
                margin-bottom: 2rem;
            }

            .radios {
                font-size: 2rem;
                margin-bottom: 2rem;

                input {
                    margin-left: 2rem;
                }

                label {
                    display: inline-block;
                    vertical-align: middle;

                    &:not(&:last-of-type) {
                        margin-right: 30px;
                    }
                }
            }

            .cpf_field {
                width: 30rem;
                height: 4rem;
                font-size: 3rem;
                border-color: @primary-color;
                border-radius: 10px;
                text-align: center;
            }

            input:focus {
                outline: none;
                border-color: @primary-dark;
            }

            .cpf-container {
                height: 100%;
                width: 100%;
                display: flex;
                justify-content: center;
            }

            .method-buttons-container {
                display: grid;
                width: 100%;
                background-color: @white;
                max-height: 100%;
                grid-template-rows: 0.4fr 3fr;
                span {
                    color: @primary-dark;
                }
                .method-buttons {
                    margin: 0;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    overflow: auto;
                    justify-content: space-around;
                    // &.casback-campaign {
                    //     background-color: red;
                    // }
                }
                &.casback-campaign {
                    grid-template-rows: auto 0.4fr 3fr;
                }
            }
        }

        .payment-footer {
            // position: absolute;
            display: flex;
            flex-direction: row;
            margin: 10px 0;
            bottom: 0;
            left: 0;
            width: 100%;
            justify-content: center;
            align-items: center;
            height: 100px;
            animation: upper-in 0.4s;
            will-change: transform, opacity;

            button {
                margin: 0 30px;
                width: 50%;
                text-transform: uppercase;
            }
        }
    }
}

.info-model {
    position: fixed;
    /* Fallback for older browsers */
    left: 0;
    right: 0;
    top: 10%;
    bottom: 10%;
    margin: auto;
    width: calc(100vw - 360px);
    max-width: 800px;
    min-width: 300px;
    background: @white;
    border-radius: 25px;
    z-index: 2;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    padding: 40px 20px;
    height: 40vh;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;

    img {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        background: white;
        max-height: 1000px;
        max-width: 700px;
        min-height: 400px;
        margin: auto;
        border-radius: 10px;
        padding-bottom: 30px;
    }
    .image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            max-height: 1000px;
            max-width: 700px;
        }
    }

    h2 {
        margin: 45px 0;
        font-size: 2em;
    }

    .message {
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        min-height: 20px;

        span {
            font-size: 2rem;
            text-align: center;
            white-space: pre-line;
        }

        &.bold {
            span {
                font-weight: bold;
            }
        }
        .warning-message {
            color: rgb(204, 133, 0);
        }
    }

    .message_pager {
        display: flex;
        justify-content: center;
        flex-direction: row;

        img {
            height: 380px;
            width: 380px;
        }

        p {
            font-size: 28px;
            padding: 0 20px;
        }
    }

    .button-default {
        margin: 10px;
    }
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
    will-change: background-color;
    -webkit-transition: background-color 1s ease-in-out;
    transition: background-color 1s ease-in-out;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;

    &.success {
        background: rgba(120, 179, 72, 0.8);
    }
}

#keyboard {
    .keyboard;
    bottom: 400px;
}

@media (max-width: 698px) {

    // Gertec SK210
    .payment .payment_container {
        padding: 10px;

        .header {
            margin-bottom: 20px !important;

            span {
                font-size: 30px !important;
                margin: 0 20px !important;
            }

            .button-default {
                margin: 0 !important;
            }
        }

        .content {
            max-height: calc(100% - 80px) !important;

            span {
                margin-top: 10px !important;
                margin-bottom: 20px !important;
                font-size: 20px !important;
            }

            .buttons {
                margin-bottom: 1rem !important;
            }

            .button-default {
                width: 230px !important;
            }

            .method-buttons-container {
                .method-buttons {
                    padding-bottom: 20px;

                    .button-default {
                        width: 230px !important;
                    }
                }
            }
        }
    }

    .info-model {
        width: calc(100vw - 110px) !important;
        padding: 0 15px !important;
        height: 60vh;
        // display: grid;
        // grid-template-rows: 1fr 3fr 1fr;
        .image-container {
            img {
                min-height: 120px;
                max-height: 200px !important;
                padding-bottom: 0;
            }
        }

        img {
            min-height: 150px;
            max-height: 200px !important;
            padding-bottom: 0;
        }

        .message {
            padding: 10px 0 !important;
            min-height: 20px;
            span {
                font-size: 20px !important;
            }
        }

        h2 {
            margin: 10px 0;
            font-size: 1.3em;
        }
    }
    .payment {
        .payment_containter_gom {
            height: 100%;
            grid-template-rows: 65px auto 70px 0;
            .title-page {
                // margin: 5px 0 10px 0 !important;
                display: none !important;

                img {
                    display: none !important;
                }
            }

            .header {
                // margin-bottom: 20px !important;

                span {
                    font-size: 25px !important;
                    color: @primary-dark;
                    text-transform: uppercase;
                    padding: 0 10px;

                    &:last-child {
                        margin: auto;
                    }
                }

                .button-default {
                    min-width: 180px !important;
                    height: 50px !important;
                }
            }

            .content {
                // max-height: calc(100vh - 240px) !important;

                .cpf-container {
                    margin: auto 0;
                }

                span {
                    font-size: 22px !important;
                    margin-top: 10px !important;
                    margin-bottom: 25px !important;
                }

                .method-buttons-container {

                    .method-buttons {
                        overflow: auto;

                        button {
                            margin: 5px;
                        }
                    }
                }
            }

            .payment-footer {
                margin: 0 !important;
                height: 70px !important;

                button {
                    margin: 0 5px !important;
                    width: 45% !important;
                    text-transform: uppercase;
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .payment_container {
        .content {
            span {
                font-size: 1.7rem;
            }

            .buttons {
                margin-bottom: 1.3rem;
            }

            .radios {
                font-size: 1.5rem;
                margin-bottom: 1.5rem;
            }

            .cpf_field {
                width: 27rem;
                height: 3.5rem;
                font-size: 2.5rem;
            }
        }
    }

    .info-model {
        /* left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important; */
        width: calc(100vw - 140px) !important;
        max-width: 700px !important;
        min-width: 400px !important;
        padding: 0 10px;
        height: 45vh;
        .image-container {
            img {
                min-height: 300px;
                max-height: 360px;
                padding-bottom: 0;
            }
        }

        img {
            // max-width: 500px;
            max-width: 150px;
            max-height: 200px;
        }

        .wallet-modal {
            max-height: 1000px;
            max-width: 600px;
        }

        .message_pager {
            img {
                height: 280px;
                width: 280px;
            }

            p {
                font-size: 21px;
                padding: 5px 15px;
            }
        }

        .message {
            padding-top: 20px;
            text-align: center;
            min-height: 25px;
            span {
                font-size: 22px;
                text-align: center;
            }
        }

        h2 {
            margin: 35px 0;
            font-size: 1.8em;
        }

        .button-default {
            min-width: 200px;
            height: 70px;
        }
    }

    #keyboard {
        .keyboard;
        max-width: 700px;
        font-size: 20px;
    }

    .payment  {
        .payment_containter_gom {
            grid-template-rows: 130px 100px 1fr 100px 0;
            .title-page {
                height: 130px;
                margin: 0;
                img {
                    height: 110px;
                }
            }

            .header {
                span {
                    font-size: 2.5rem !important;
                    color: @primary-dark;
                    // font-weight: bold;
                    text-transform: uppercase;

                    &:last-child {
                        margin: auto;
                    }
                }

                .button-default {
                    // min-width: 230px !important;
                    height: 4.5rem !important;
                }
            }

            .content {
                .cpf-container {
                    display: flex;
                    justify-content: center;
                    // margin: auto;
                }

                .method-buttons-container {

                    .method-buttons {
                        overflow: auto;
                    }
                }
            }
            .payment-footer {
                margin: 0;
                height: 100px;
            }
        }
    }
}

@media (orientation: landscape) {
    .payment_container {
        padding: 10px;

        .header {
            margin-bottom: 20px !important;

            span {
                font-size: 40px !important;
                margin: 0 20px !important;
            }

            .button-default {
                margin: 0 !important;
            }
        }

        .content {
            max-height: calc(100% - 80px) !important;
            display: grid;

            span {
                margin-top: 10px !important;
                margin-bottom: 20px !important;
                font-size: 20px !important;
            }

            .buttons {
                margin-bottom: 1rem !important;
            }

            .button-default {
                width: 230px !important;
            }

            .method-buttons-container {
                padding-bottom: 30px !important;

                .method-buttons {
                    display: flex !important;
                    flex-direction: row;
                    flex-wrap: wrap;
                    padding-bottom: 20px;
                    align-items: center !important;
                    justify-content: center !important;

                    .button-default {
                        width: 230px !important;
                        margin: 10px 20px !important;
                    }
                }
            }
        }
    }

    .info-model {
        /* left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;*/
        width: calc(100vw - 380px) !important;
        padding: 20px !important;
        height: 80vh;

        img {
            max-height: 300px !important;
            padding-bottom: 0;
            min-height: 200px;
        }

        .message {
            padding: 15px 0 !important;

            span {
                font-size: 20px !important;
            }
        }
    }

    .payment {
        .payment_containter_gom {
            grid-template-rows: 80px 80px 1fr 100px 0;
            height: calc(100vh - 30px);
            .title-page {
                height: 80px;
                margin: 0;
                img {
                    height: 50px;
                }
            }

            .header {
                padding: 0 50px;
                span {
                    font-size: 2rem;
                    color: @primary-dark;
                    // font-weight: bold;
                    text-transform: uppercase;

                    &:last-child {
                        margin: auto;
                    }
                }

                .button-default {
                    // min-width: 230px;
                    height: 4.5rem;
                }
                .btn-big {
                    width: 50px !important;
                    height: 50px !important;
                }
            }

            .content {
                height: auto;
                min-height: unset;
                .cpf-container {
                    margin: auto;
                    height: 100%;
                }

                .method-buttons-container {
                    // grid-template-rows: auto auto auto;
                    span {
                        font-size: 1.8rem;
                        margin: 1.5rem 0;
                        color: @primary-dark;
                    }
                    .method-buttons {
                        overflow: auto;
                        button {
                            margin: 0 10px 10px 0;
                        }
                    }
                }
            }
            .payment-footer {
                margin: 0;
                height: 100px;
            }
        }
    }
}

// Transição para method-buttons-container (entra pela direita, sai pela direita)
.slide-fade-gom-enter-active {
    position: absolute;
    top: 0;
    left: 2rem;
    right: 2rem;
    width: calc(100% - 4rem);
    min-width: calc(100% - 4rem);
    max-width: calc(100% - 4rem);
    box-sizing: border-box;
    flex-shrink: 0;
    will-change: transform;
    transform: translate3d(100%, 0, 0);
    transition: transform .5s ease-in-out;
}

.slide-fade-gom-enter-to {
    transform: translate3d(0, 0, 0);
}

.slide-fade-gom-leave-active {
    position: absolute;
    top: 0;
    left: 2rem;
    right: 2rem;
    width: calc(100% - 4rem);
    min-width: calc(100% - 4rem);
    max-width: calc(100% - 4rem);
    box-sizing: border-box;
    flex-shrink: 0;
    will-change: transform;
    transform: translate3d(0, 0, 0);
    transition: transform .5s ease-in-out;
}

.slide-fade-gom-leave-to {
    transform: translate3d(100%, 0, 0);
}

.slide-fade-gom-leave-to,
.slide-fade-gom-enter-to {
    will-change: auto;
}

// Transição para cpf-container (entra pela esquerda, sai pela esquerda)
.slide-fade-left-gom-enter-active {
    position: absolute;
    top: 0;
    left: 2rem;
    right: 2rem;
    width: calc(100% - 4rem);
    min-width: calc(100% - 4rem);
    max-width: calc(100% - 4rem);
    box-sizing: border-box;
    flex-shrink: 0;
    will-change: transform;
    transform: translate3d(-100%, 0, 0);
    transition: transform .5s ease-in-out;
}

.slide-fade-left-gom-enter-to {
    transform: translate3d(0, 0, 0);
}

.slide-fade-left-gom-leave-active {
    position: absolute;
    top: 0;
    left: 2rem;
    right: 2rem;
    width: calc(100% - 4rem);
    min-width: calc(100% - 4rem);
    max-width: calc(100% - 4rem);
    box-sizing: border-box;
    flex-shrink: 0;
    will-change: transform;
    transform: translate3d(0, 0, 0);
    transition: transform .5s ease-in-out;
}

.slide-fade-left-gom-leave-to {
    transform: translate3d(-100%, 0, 0);
}

.slide-fade-left-gom-leave-to,
.slide-fade-left-gom-enter-to {
    will-change: auto;
}

.bounce-enter-active {
    animation: bounce-in 0.4s;
    will-change: transform;
}

.bounce-leave-active {
    animation: bounce-in 0.3s reverse;
    will-change: transform;
}

.bounce-enter-active,
.bounce-leave-active {
    animation-fill-mode: both;
}

.bounce-enter-active:not(:hover),
.bounce-leave-active:not(:hover) {
    will-change: auto;
}

@keyframes bounce-in {
    0% {
        transform: scale3d(.5, .5, 1);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        transform: scale3d(1, 1, 1);
        opacity: 1;
    }
}

@keyframes upper-in {
    0% {
        transform: translate3d(0, 100px, 0);
        opacity: 0;
    }

    100% {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Payment.vue